import { Link } from "react-router-dom";

var CurrentUser = require('lib/account/CurrentUser');
var Features = require('lib/account/Features');

var Modal = require('components/utility/AltModal');
var Glyphicon = require("components/utility/icons/Glyphicon");
var TextTypes = require('lib/academic/TextTypes');

var SmartBookSearch = require("components/reading/books/SmartBookSearch");
var LogReadingModal = require("components/reading/books/LogReadingModal");

var BookDisplay = require("components/reading/books/BookDisplay")

var Spinner = require("components/utility/Spinner");
var ReactTooltip = require("react-tooltip");
var BookTextVariety = require("components/reading/books/BookTextVariety");
var WhooosReadingServices = require('lib/web/WhooosReadingServices');
var StudentMetrics = require("lib/data/StudentMetrics");

require("reading/books/book_action_section.scss");

class BookActionModal extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			// Note there is also a selectedBook (for log reading only) in StudentHomePage :(
			selectedBook: null,

			loading: false, quiz: null, bookStatus: null, 
			showBookModal: false, bookKeyIndex: 0
		}
	}

	isFirstBook() {
		return (_.size(this.props.existingBooks) == 0);
	}

	openQuiz(e) {
		$wr.nope(e)
		// Don't check text variety for quizzes
		this.setState({ loading: true });
		this.props.openBookActivity("quiz", this.props.selectedBook);
	}

	openLogReading(e) {
		$wr.nope(e)
		this.setState({ showBookModal: true });
		this.refs.modal.hide();
	}

	// closeLogReading(readingWasLogged) {
	// 	if (readingWasLogged) {
	// 		this.setState({ showBookModal: false, bookKeyIndex: (this.state.bookKeyIndex + 1) });
	// 	} else {
	// 		this.setState({ showBookModal: false });
	// 	}
	// }

	openReview(e) {
		$wr.nope(e)
		this.setState({ loading: true });
		this.props.openBookActivity("review", this.props.selectedBook);
	}

	openExcercise(e) {
		$wr.nope(e)
		this.setState({ loading: true });
		this.props.openBookActivity("exercise", this.props.selectedBook);
	}

	openQuestions(e) {
		$wr.nope(e)
		this.setState({ loading: true });
		this.props.openBookActivity("question", this.props.selectedBook);
	}

	textVarietySelected(book) {
		this.setState({ loading: true });
		this.props.openBookActivity(this.state.requestedAction, book);
	}

	checkTextVariety(action) {
		if (this.props.studentDashboard) {
			return true;
		}
		if (this.state.selectedBook) {
			if (this.state.selectedBook.overridden) {
				this.setState({
					getTextVariety: true,
					requestedAction: action
				});
				return false
			}
			return true
		}
		return false
	}

	resetTextVariety() {
		this.setState({
			getTextVariety: false 
		});
	}

	submitOverride(attribute_name,text_id,value) {
		var user = CurrentUser.get()
		var override_data = {
			instance_id: text_id,
			instance_type: "book",
			attribute_name: attribute_name,
			value: value,
			user_id: user.id,
			user_role: user.role,
		}

		var url = WhooosReadingServices.Matilda.url("/overrides");
		$wr.postJSON(url,{override:override_data}, function(data) {
			var newBook = $.extend({}, this.props.book)
			newBook.text_variety = value
		}.bind(this));
	}

	setBookStatus(value) {
		this.setState({ bookStatus: value });
	}

	show() {
		this.refs.modal.show();
	}

	renderTaskIcon(typeName) {
		if (this.props.selectedBook && this.props.selectedBook.taskItems) {
			var taskItems = this.props.selectedBook.taskItems
			var requiredTaskItems = _.where(taskItems, { subject_type: typeName }).length;
			var finishedTaskItems = _.where(taskItems, { subject_type: typeName, draft: false }).length;
			if (requiredTaskItems === 0) {
				return (
					<span className="subtaskIcon grayIcon">Optional</span>
				)
			}
			else if (requiredTaskItems <= finishedTaskItems) {
				return (
					<span className="subtaskIcon greenIcon">Completed</span>
				)
			}
			else if (requiredTaskItems > finishedTaskItems) {
				return (
					<span className="subtaskIcon redIcon">Required</span>
				)
			}
			else {
				return (
					<span className="subtaskIcon grayIcon">Optional</span>
				)
			}
		}
	}

	renderChoiceModal() {
		if (this.state.loading) {
			var loadingIcon = (
				<div><Spinner placeholder={ true } scale={ 1.7 } /></div>
			);

		} else if (this.state.getTextVariety) {
			var modalContent = (
				<BookTextVariety reset={this.resetTextVariety} book={ this.state.selectedBook }
				onSubmit={ this.textVarietySelected } />
			);
		} else {
			var metrics = _.values(StudentMetrics.TYPES);
			var expectations = _.pluck(this.props.expectations, "metric");

			var containsReadingExpectation = false;

			var actions = _.sortBy(metrics, metric => {
				return expectations.includes(metric);
			});

			var actions = actions.reverse().map(function (action) {
				if (action == StudentMetrics.TYPES.QUIZZES_PASSED) {
					return (
						<a href="#" key={action} className="actionOp quizOp soloOp" onClick={this.openQuiz}
							data-tip="Finish the book before you take a quiz!">
							<img src={require("reading/take-a-quiz.png")} alt="Take a Quiz" />
							<span>Take a Quiz</span>
							{ this.renderTaskIcon('Quiz') }
						</a>
					)
				} else if (action == StudentMetrics.TYPES.MINUTES || action == StudentMetrics.TYPES.PAGES) {
					if (Features.isEnabled(Features.LOG_READING) && !containsReadingExpectation) {
						containsReadingExpectation = true;
						return (
							<a href="#" key={ action } className="actionOp logReadingOp" onClick={ this.openLogReading }>
								<img src={ require("reading/log-reading.png") } alt="Log Reading" />
								<span>Log Reading</span>
								{ this.renderTaskIcon('Reading')}
							</a>
						); 
					}
				} else if (action == StudentMetrics.TYPES.EXERCISES) {
					if (Features.isEnabled(Features.DIGITAL_EXERCISES)) {
						return (
							<a href="#" key={ action } className="actionOp" onClick={ this.openExcercise }>
								<img src={ require("reading/exercise-small.png") } alt="Do an Exercise" />
								<span>Start an Exercise</span>
								{ this.renderTaskIcon('Exercise')}
							</a>
						);
					}
				} else if (action == StudentMetrics.TYPES.QUESTIONS) {
					return (
						<a href="#" key={ action } className="actionOp questionOp" onClick={ this.openQuestions }>
							<img src={ require("reading/question.png") } alt="Answer a Question" />
							<span>Answer a Question</span>
							{ this.renderTaskIcon('Practice Question')}
						</a>
					)
				} else if (action == StudentMetrics.TYPES.REVIEWS) {
					return (
						<a href="#" key={ action } className="actionOp" onClick={ this.openReview }>
							<img src={ require("reading/review-small.png") } alt="Write a Review" />
							<span>Write a Review</span>
							{ this.renderTaskIcon('Review')}
						</a>
					)
				}
			}.bind(this))

			try {
				if (actions) {
					actions = _.filter(actions, function (action) { return action !== undefined })
					var completedActions = _.filter(actions, function(action) {
						var iconClass = action.props.children[action.props.children.length - 1].props.className
						return iconClass.includes('greenIcon')
					})
					var requiredActions = _.filter(actions, function(action) {
						var iconClass = action.props.children[action.props.children.length - 1].props.className
						return iconClass.includes('redIcon')
					})
					var optionalActions = _.filter(actions, function(action) {
						var iconClass = action.props.children[action.props.children.length - 1].props.className
						return iconClass.includes('grayIcon')
					})
				}
				actions = completedActions.concat(requiredActions).concat(optionalActions)
			}
			catch (e) {
				// silence is golden
			}

			var modalContent = (
				<div className="secondaryOptions">
					<div className="actionsContainer">
						{ actions }
					</div>
				</div>
			);
		}

		if (this.props.selectedBook) {

			if (this.props.selectedBook.url) {
				var bookDisplay = (
					<BookDisplay textID={ this.props.selectedBook.text_id } coverWidth={ 120 }
						showCover >

						<br /><a href={ this.props.selectedBook.url } target="_blank" className="buttonSuccess">
							Read it Now!
						</a>

					</BookDisplay>
				);

			} else {
				var bookDisplay = (
					<BookDisplay textID={ this.props.selectedBook.text_id } coverWidth={ 70 }
						showCover showAuthor />
				);

			}
		}

		return (
			<Modal className="bookActionModal" ref="modal"
				headerText="What do you want to do next?" onShow={ this.setBookStatus.bind(this, null) }>
				<div className="selectedBookHeader">
					{ bookDisplay }
				</div>
				{ loadingIcon }
				<div className="bookOptions">
					{ modalContent }
				</div>
			</Modal>
		);
	}

	clearSelectedBook() {
		this.setState({ selectedBook: null })
	}

	componentDidMount() {
		$(window.document).on("clear-selected-book", this.clearSelectedBook)
	}

	componentWillUnmount() {
		$(window.document).off("clear-selected-book", this.clearSelectedBook)
	}

	onBack(bookStatus) {
		this.refs.bookActionModal.show();
		this.setState({ showBookModal: false }, () => {
			this.setBookStatus(bookStatus)
		})
	}

	render() {
		var actionModal = this.renderChoiceModal();
		var bookModal = (
			<LogReadingModal initialBook={ this.props.selectedBook }
				open={ this.state.showBookModal } onClose={ this.closeLogReading }
				key={ this.props.selectedBook } />
		);

		return (
			<div className="bookActionSection studentDashboard">
				{ actionModal }
				{ bookModal }
			</div>
		)
	}

}

BookActionModal.propTypes = StrictPropTypes({
	openBookActivity: PropTypes.func.isRequired,
	popularBooks: PropTypes.array,
	existingBooks: PropTypes.array,
	studentDashboard: PropTypes.bool,
	openActivityType: PropTypes.string,
	selectedBook: PropTypes.object,
	expectations: PropTypes.array

});

var FINISHED = "finished";
var STILL_READING = "reading";


module.exports = BookActionModal;


// WEBPACK FOOTER //
// ./modules/components/reading/books/BookActionModal.js